import { useEffect } from "react"
import { useState } from "react"
import API from "../../services/API"
import { MenuItem, TextField } from "@mui/material"

export default function Kind({label, value, onChange, required}){

    const [kinds, setKinds] = useState(null)

    useEffect(() => {

        API.get('/course/kinds')
            .then(r => setKinds(r.data))

    }, [])

    return kinds &&

        <TextField
            select
            label={label || 'Type de formation'}
            value={value?.id || ''}
            onChange={e => onChange(
                kinds.find(k => k.id === e.target.value)
            )}
            size='small'
            required={required}
        >
            {kinds
                .sort((a,b) => a.title > b.title ? 1 : -1)
                .map(k =>
                    <MenuItem key={k.id} value={k.id}>{k.title}</MenuItem>  
                )
            }
        </TextField>
}